/**
 * @copyright
 * Copyright(c) 2020 SICK AG
 */
const demoThemesURLs = new Map([['light', ['/node_modules/@sick-davinci/theme-base/theme/light_theme.css', '/node_modules/@sick-davinci/theme-base/theme/light_ddg_theme.css']], ['dark', ['/node_modules/@sick-davinci/theme-base/theme/dark_theme.css', '/node_modules/@sick-davinci/theme-base/theme/dark_ddg_theme.css']]]);
/**
 * Call from a DaVinci Demo during dev-time
 *
 * @param toggleId - id of the davinci-toggle which switches between light and dark theme
 */

export function setupThemeTogglerForDaVinciDemo(toggleId) {
  const themeChange = setupThemeToggling(demoThemesURLs, 'light'); // eslint-disable-next-line @typescript-eslint/no-explicit-any

  document.getElementById(toggleId).addEventListener('change', ({
    target
  }) => {
    if (target.checked) {
      themeChange('dark');
    } else {
      themeChange('light');
    }
  });
}
/**
 * Helper function which enables theme toggling for examples/demos with the provided davinci-toggle-switch
 *
 * @param styleURLs - style names and accoridings css urls
 * @param initialStyle - initial style applied at start
 */

export function setupThemeToggling(styleURLs, initialStyle) {
  // quickchart based charts must be updated using the ThemeService
  function forceThemeCheck() {
    window.setTimeout(() => {
      // wait for the DOM to be updated
      window.requestAnimationFrame(() => {
        var _forceThemeCheck;

        // wait for the browser to finish the reflow
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (_forceThemeCheck = window['forceThemeCheck']) === null || _forceThemeCheck === void 0 ? void 0 : _forceThemeCheck.call();
      });
    }, 0);
  }

  function applyStyle(style) {
    document.querySelectorAll('.davinci-theme').forEach(l => l.remove());
    const linkLoads = new Array();
    styleURLs.get(style).forEach(url => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = url;
      link.className = 'davinci-theme';
      document.head.appendChild(link);
      linkLoads.push(new Promise(res => link.addEventListener('load', () => res())));
    });
    Promise.all(linkLoads).then(() => forceThemeCheck());
  }

  applyStyle(initialStyle);
  return applyStyle;
}
